module.exports = __webpack_public_path__ + "static/media/deals.5c648b9d.svg";